import React from "react";
import { Box, Card, CardContent, Chip, Grid, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";

const API = (process.env.REACT_APP_API_URL || "http://localhost:8000/api").replace(/\/$/, "");
const MEDIA_BASE = (process.env.REACT_APP_MEDIA_URL || API.replace(/\/api$/, "")).replace(/\/$/, "");

const toAbsoluteMediaUrl = (value) => {
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  return `${MEDIA_BASE}${value.startsWith("/") ? value : `/${value}`}`;
};

const EndoscopyRecordDetailsPage = () => {
  const location = useLocation();
  const record = location.state?.record;

  if (!record) {
    return (
      <Grid container sx={{ p: 2 }}>
        <Typography>No record selected.</Typography>
      </Grid>
    );
  }

  return (
    <Grid container sx={{ p: 2 }}>
      <Card sx={{ width: "100%" }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>Endoscopy Result Details</Typography>
          <Typography><strong>Ticket Number:</strong> {record.ticket_display || "-"}</Typography>
          <Typography><strong>Patient:</strong> {record.patient_display?.name || "-"}</Typography>
          <Typography><strong>Patient ID:</strong> {record.patient_display?.id || "-"}</Typography>
          <Typography><strong>Test Name:</strong> {record.test_display?.name || "-"}</Typography>
          <Typography><strong>Test Result:</strong> {record.test_result || "-"}</Typography>
          <Typography><strong>Notes:</strong> {record.notes || "-"}</Typography>
          <Typography><strong>Uploaded Photo/Report:</strong> {record.report_image ? "Uploaded" : "-"}</Typography>
          {record.report_image ? (
            <Box sx={{ mt: 1 }}>
              <Box
                component="img"
                src={toAbsoluteMediaUrl(record.report_image)}
                alt="Endoscopy report"
                onClick={() => window.open(toAbsoluteMediaUrl(record.report_image), "_blank")}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                }}
                sx={{
                  width: 220,
                  maxWidth: "100%",
                  height: 160,
                  objectFit: "cover",
                  borderRadius: 1,
                  border: "1px solid #ddd",
                  cursor: "pointer",
                }}
              />
            </Box>
          ) : null}
          <Box sx={{ mt: 1 }}>
            <Chip size="small" label={record.status || "Pending"} color={record.status === "Completed" ? "success" : record.status === "In Review" ? "warning" : "default"} />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default EndoscopyRecordDetailsPage;
